export default {"src":"/_next/static/media/linkedin-icon.6ca2c993.svg","height":34,"width":35,"blurWidth":0,"blurHeight":0};